import { useEffect } from "react";
import { identifyMe, syncMyAvatar } from "../world/humans/store.js";
import { useSession } from "./session.js";

/** Tells the avatar store who is signed in and reads the saved character once per user. */
export function useMyAvatarSync(): void {
  const { user } = useSession();
  const id = user?.id;
  const name = user?.displayName;
  useEffect(() => {
    if (id) identifyMe(id, name ?? "");
    void syncMyAvatar();
  }, [id, name]);
}
